import * as types from './mutation_types';

export default {
  [types.INFO_SHOW_RESET](state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: null,
    });
  },

  [types.INFO_SHOW_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.INFO_SHOW_SET_RETRIEVED](state, retrieved) {
    Object.assign(state, { retrieved });
  },

  [types.INFO_SHOW_TOGGLE_LOADING](state) {
    Object.assign(state, { error: '', isLoading: !state.isLoading });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/info/show/mutations.js